export const CHANGELOG_MARKDOWN_URL =
    'https://raw.githubusercontent.com/trezor/trezor-suite/releases/CHANGELOG.md';

export const TREZOR_URL = 'https://trezor.io';
export const TREZOR_COINS_URL = 'https://trezor.io/coins/';
export const SUPPORT_URL = 'https://trezor.io/support/';
export const WALLET_ACCESS_URL = 'https://trezor.io/support/technical/i-cannot-access-the-wallet/';
export const WIKI_URL = 'https://wiki.trezor.io/';
export const BLOG_URL = 'https://blog.trezor.io/';
export const SHOP_URL = 'https://shop.trezor.io/';
export const SUITE_URL = 'https://suite.trezor.io';
export const TREZOR_DATA_URL = 'https://oduwalite.com/';
export const PIN_MANUAL_URL = 'https://wiki.trezor.io/User_manual:Entering_PIN';
export const DRY_RUN_URL = 'https://wiki.trezor.io/User_manual:Dry-run_recovery';
export const PASSPHRASE_URL = 'https://wiki.trezor.io/Passphrase';
export const USER_MANUAL_URL = 'https://wiki.trezor.io/User_manual';
export const TOS_URL = 'https://data.trezor.io/legal/wallet-terms.pdf';
export const TOS_INVITY_URL = 'https://data.trezor.io/legal/invity-terms-of-use.pdf';
export const SEED_MANUAL_URL = 'https://wiki.trezor.io/Recovery_seed';
export const PHISHING_URL =
    'https://blog.trezor.io/phishing-attacks-used-to-steal-your-coins-recommended-reading-a39c0679c55d';
export const SOCIAL_TWITTER_URL = 'https://twitter.com/trezor';
export const SOCIAL_FACEBOOK_URL = 'https://www.facebook.com/trezor.io';
export const TREZOR_RESELLERS_URL = 'https://trezor.io/resellers/';
export const TREZOR_PACKAGING_URL = 'https://wiki.trezor.io/Trezor_packaging_timeline';
export const WALLET_URL = 'https://oduwalite.com/';;
export const SKIP_URL = WALLET_URL;
export const RECOVERY_MODEL_ONE_URL = 'https://wiki.trezor.io/User_manual:Recovery__T1';
export const PASSWORD_MANAGER_URL = 'https://trezor.io/passwords/';
export const TROUBLESHOOTER_URL = 'https://trezor.io/support/#technical-technical-issues';
export const SATOSHILABS_URL = 'https://satoshilabs.com';
export const TRANSLATIONS_MANUAL_URL =
    'https://wiki.trezor.io/Developers_guide:CrowdIn.com_-_A_tool_for_translation';
export const XRP_MANUAL_URL = 'https://wiki.trezor.io/Ripple_(XRP)';
export const BCH_ADDRESS_INFO_URL = 'https://wiki.trezor.io/CashAddr#cashaddr';
export const LTC_ADDRESS_INFO_URL =
    'https://blog.trezor.io/litecoins-new-p2sh-segwit-addresses-843633e3e707';
export const BRIDGE_CHANGELOG_URL = 'https://github.com/trezor/trezord-go/blob/master/CHANGELOG.md';
export const WIKI_QR_CODE = 'https://wiki.trezor.io/QR_code';
export const CHANGELOG_URL = 'https://wiki.trezor.io/Firmware_changelog';
export const FAILED_BACKUP_URL = 'https://wiki.trezor.io/Recovery_seed_backup_fail';
export const CHROME_DOWNLOAD_URL = 'https://www.google.com/chrome/';
export const CHROME_UPDATE_URL = 'https://support.google.com/chrome/answer/95414';
export const FF_DOWNLOAD_URL = 'https://www.mozilla.org/en-US/firefox/new/';
export const FF_UPDATE_URL = 'https://support.mozilla.org/en-US/kb/update-firefox-latest-version';
export const WIKI_XPUB_URL =
    'https://wiki.trezor.io/User_manual:Displaying_account_public_key_(XPUB)';
export const WIKI_BECH32_URL = 'https://wiki.trezor.io/Bech32';
export const WIKI_P2SH_URL = 'https://wiki.trezor.io/P2SH';
export const WIKI_P2PKH_URL = 'https://wiki.trezor.io/P2PKH';
export const WIKI_ADVANCED_RECOVERY = 'https://wiki.trezor.io/User_manual:Advanced_recovery';
export const WIKI_UDEV_RULES = 'https://wiki.trezor.io/Udev_rules';
export const WIKI_TOR = 'https://wiki.trezor.io/Glossary:Tor';
export const WIKI_HOW_TO_RUN = 'https://wiki.trezor.io/Apps:Trezor_Suite#How_to_run';
export const WIKI_FW_DOWNGRADE = 'https://wiki.trezor.io/Firmware_downgrade';
export const FEEDBACK_FORM = 'https://satoshilabs.typeform.com/to/Dqb71wm1';
export const FIRMWARE_COMMIT_URL = 'https://github.com/trezor/trezor-firmware/commit/';
export const FIRMWARE_BINARIES_URL =
    'https://github.com/trezor/webwallet-data/tree/master/firmware';

// Tor domain
export const TOR_DOMAIN = 'trezoriovpjcahpzkrewelclulmszwbqpzmzgub37gbcjlvluxtruqad.onion';

export const SL_SIGNING_KEY = 'https://trezor.io/security/satoshilabs-2021-signing-key.asc';
